"use strict";

exports.__esModule = true;
exports.BM_EXPERIMENTS = void 0;
const BM_EXPERIMENTS = exports.BM_EXPERIMENTS = {
  MOTO: 'specs.membership.EnableMoto',
  ONBOARDING_CHECKLIST: 'specs.membership.OnboardingChecklist',
  DASHBOARD_CONTENT_UPDATES: 'specs.membership.DashboardContentUpdates',
  DUPLICATE_EMAIL_MODAL: 'specs.membership.DuplicateEmailModal',
  REMOVE_PLAN_LIMIT: 'specs.membership.RemovePlanLimit',
  WORKAROUND_BENEFITS_FLICKER: 'specs.membership.WorkaroundBenefitsFlicker',
  CAIRO_TABLE: 'specs.membership.CairoTable',
  ENABLE_FORM_PREVIEW: 'specs.membership.EnableFormPreview',
  ENABLE_FORM_RULES: 'specs.membership.EnableFormRules',
  REMOVE_ANALYTICS: 'specs.membership.RemoveAnalyticsWithNoPlansSold',
  ALLOW_CANCELLATION_MODAL: 'specs.membership.AllowPlanCancellationModal',
  CUSTOM_FORMS_IMPROVEMENTS: 'specs.membership.CustomFormsImprovements',
  NEW_PRICE_LIMIT: 'specs.membership.NewPriceLimit',
  TYP_URL_VALIDATION: 'specs.membership.TypUrlValidation',
  TAX_NAME: 'specs.membership.TaxNameInBM',
  SHOW_BENEFIT_EXTENSIONS: 'specs.membership.showBenefitExtensions',
  UPDATE_PLAN_DURATION_OPTION: 'specs.membership.UpdatePlanDurationOptions',
  SUPPORT_DEALER_DYNAMIC_PARAMS: 'specs.membership.SupportDealerDynamicParams'
};
//# sourceMappingURL=bm.js.map